$(() => {
  // 写真選択時の処理
  $('.js-logo-selector-container').on('click', '.js-select-logo', e => {
    const $selectLogo = $(e.currentTarget);
    $('.js-logo-id').val($selectLogo.data('id'));
    $('.js-selected-logo').removeClass('unselected');
    $('.js-selected-logo img').attr('src', $selectLogo.data('src')).show();
    $selectLogo.closest('.js-select-logo-modal').modal('hide');
    return false;
  });

  // 写真設定解除時の処理
  $('.js-logo-unset').on('click', () => {
    $('.js-logo-id').val('');
    $('.js-selected-logo').addClass('unselected');
    $('.js-selected-logo img').hide();
    return false;
  });
});
